
            import "data:text/css,.m-mainInfo-55768e082b%7Bwidth:100%25;height:auto;position:fixed;top:50%25;transform:translateY(-50%25);margin-left:3em;text-align:left%7D.m-title-55768e082b%7Bfont-size:2vw;color:#72727d%7D.m-hash-55768e082b%7Bfont-size:7vw;text-align:left;font-weight:600;max-width:85%25%7D";
            const result = {"mainInfo":"m-mainInfo-55768e082b","title":"m-title-55768e082b","hash":"m-hash-55768e082b"};
            export default result;
          